import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SeoHead from '@/components/feature/SeoHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroBanner from './components/HeroBanner';
import FeaturedVideos from './components/FeaturedVideos';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import { siteInfo, faqs } from '@/mocks/site';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const recentArticles = articles.slice(0, 3);

  return (
    <>
      <ScrollToTop />
      <SeoHead
        title="国产在线观看-高清国产视频免费在线观看平台"
        description="国产在线观看首选平台，海量高清国产视频免费畅享，无需下载即可在线观看最新国产影视剧、综艺、短片，支持手机电脑多端流畅播放，每日更新内容，给你最极致的国产视频在线观看体验。"
        keywords="国产在线观看,国产视频在线观看,高清国产视频,国产影视在线,免费在线观看国产,国产剧在线播放,国产综艺在线观看"
        canonicalUrl={siteInfo.url}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: siteInfo.name,
          url: siteInfo.url,
          description: siteInfo.description,
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteInfo.url}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: siteInfo.name,
          url: siteInfo.url,
          description: siteInfo.description,
          email: siteInfo.email,
          telephone: siteInfo.phone,
          address: {
            '@type': 'PostalAddress',
            streetAddress: siteInfo.address,
            addressCountry: 'CN',
          },
        }}
      />

      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedVideos />
        <CategorySection />
        <LatestUpdates />

        <section className="py-14 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    影视资讯
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">最新国产影视深度解析与推荐</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {recentArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-16">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-8">关于国产在线观看平台的常见疑问</p>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
                  >
                    <button
                      className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                      onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    >
                      <h4 className="font-heading font-medium text-sm text-foreground-900 pr-4">
                        {faq.question}
                      </h4>
                      <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openFaq === index ? 'rotate-180' : ''}`}>
                        <i className="ri-arrow-down-s-line text-foreground-500"></i>
                      </span>
                    </button>
                    {openFaq === index && (
                      <div className="px-5 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <SchemaOrg
          type="FAQPage"
          data={{
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }}
        />

        <section className="py-14 md:py-16 bg-accent-500">
          <div className="w-full px-4 md:px-6 text-center">
            <div className="max-w-2xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
                立即开始您的观影之旅
              </h2>
              <p className="text-sm text-background-50/80 mb-6">
                海量高清国产视频免费在线观看，无需注册，无需下载，随时随地畅享精彩内容
              </p>
              <Link
                to="/category/dianshiju"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-accent-600 font-semibold text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                免费观看
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}